import { mapActions, mapGetters, mapMutations } from "vuex";
import { maxLength, minLength, required } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";
import { VueSlideToggle } from "vue-slide-toggle";
import listAddress from "./components/list-address/index.vue";
import editForm from "./components/edit-form-address/index.vue";
export default {
    name: "my-address",
    mixin: [validationMixin],
    data() {
        return {
            secondAddresses: [],
            payload: {
                active: 0,
                city: "",
                street: "",
                house: "",
                flat: "",
            },
            isEditMain: false,
            showLoader: false,
            validationErrors: {},
        };
    },
    components: {
        VueSlideToggle,
        listAddress,
        editForm,
    },
    // validations() {
    //   return {
    //     payload: {
    //       city: {
    //         required,
    //         minLength: minLength(1),
    //         maxLength: maxLength(30),
    //       },
    //       street: {
    //         required,
    //         minLength: minLength(1),
    //         maxLength: maxLength(50),
    //       },
    //       house: {
    //         required,
    //         minLength: minLength(1),
    //         maxLength: maxLength(8),
    //       },
    //       flat: {
    //         required,
    //         minLength: minLength(1),
    //         maxLength: maxLength(8),
    //       },
    //       active: {}
    //     },
    //   }
    // },
    created() {
        for (let i in this.user.addresses) {
            if (this.user.addresses[i].active === 0) {
                this.secondAddresses.push(this.user.addresses[i]);
            }
        }
        // console.log(this.secondAddresses)
    },
    watch: {
        user: function(newVal) {
            if (newVal) {
                this.secondAddresses = [];
                for (let i in this.user.addresses) {
                    if (this.user.addresses[i].active === 0) {
                        this.secondAddresses.push(this.user.addresses[i]);
                    }
                }
            }
        },
    },
    computed: {
        ...mapGetters({
            user: "profile/user",
        }),
        getMainAddress() {
            for (let i in this.user.addresses) {
                if (this.user.addresses[i].active === 1) {
                    return this.user.addresses[i];
                }
            }
        },
    },
    methods: {
        ...mapActions({
            fetchUserData: `profile/FETCH_USER_DATA`,
            deleteUserAddress: `profile/REMOVE_USER_ADDRESS`,
        }),
        ...mapMutations({
            changePopupMainAddress: `profile/CHANGE_POPUP_MAIN_ADDRESS`,
        }),
        closeEdit() {
            this.isEditMain = false;
        },
        removeAddress(item) {
            let obj = {};
            obj.id = item.id;
            // console.log(item.id);
            this.deleteUserAddress(obj)
                .then(() => {
                    this.$toasted.success(this.$t("youAddressRemove"));
                    this.fetchUserData();
                })
                .catch(error => {
                    if (error.response.status === 422) {
                        console.log(error.response);
                    }
                });
        },
    },
};
